import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Card, Checkbox, notification, Tooltip, Button, Row, Col, Form, Drawer, Input, Select } from 'antd'
import Request, { LAPI_URL, MEDIA_URL } from '../../../request'
import _, { set } from 'lodash';

import rightAuth from "../../../components/_utils/userRights";
import { TableComp } from 'sz-react-utils';
import { FormUtils as GetAllFormFields } from 'sz-react-utils';
import { GiSelect } from 'react-icons/gi';
import GenerateBranchInvoiceDrawer from '../../../components/drawers/generateBranchInvoiceDrawer';

let companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : {};
let dateFormat = companyDetails && companyDetails.dateFormat ? companyDetails.dateFormat : 'DD.MM.YYYY'
let userCheckBox = {}
let counsellingData = {}


const { Option } = Select;

@Form.create()
class UplaodInvoiceDrawer extends Component {
  state = {
    visible: true
  }

  onClose = () => {
    this.setState({ visible: false }, () => {
      this.props.onClose();
    })
  }

  handleSubmit = (e) => {
    const { form, counsellingData } = this.props
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      let values = _.clone(valData);
      values.data = counsellingData.usersData;
      let response = await Request.uploadBranchClaimInvoice(values);
      if (response.success) {
        notification.success({
          message: response.message
        })
      } else {
        notification.error({
          message: response.message
        })
      }
      this.onClose()
    })
  }

  render() {
    let { visible } = this.state;
    let { form: { getFieldDecorator } } = this.props
    const inputTypes = {
      fields: [
        {
          label: 'Invoice File',
          key: 'branchInvoice',
          type: 'file',
          required: true,
        },
        {
          label: 'Invoice Number',
          key: 'branchInvoiceNumber',
          type: 'text',
          required: true,
        }
      ]
    };
    return (
      <Drawer
        title={
          <div>
            <React.Fragment>
              Uplaod Invoice
            </React.Fragment>
          </div>
        }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={500}
        visible={visible}>
        <Card>
          <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
            <div>
              <GetAllFormFields
                apiurl={LAPI_URL}
                inputSchema={inputTypes}
                getFieldDecorator={getFieldDecorator}
              />
            </div>
            <Row style={{ marginTop: '20px' }}>
              <Col span={8} />
              <Col span={8}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginBottom: 10 }}
                  loading={this.props.loading}>
                  Save
                </Button>
              </Col>
              <Col span={8} />
            </Row>
          </Form>
        </Card>
      </Drawer>
    )
  }
}


class AllBranchClaimDesk extends Component {

  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    showInvoiveView: false,
    showInvoiveInboxView: false,
    generatedInvoice: {},
    invoiceId: '',
    userBranch: '',
    branchDetail: {},
    branchInvoices: [],
    userCheckBox: {},
    showUploadDrawer: false,
    totalPendingAmount: 0,
    showGenerateDrawer: false,
    financeBranchClaimDeskRights: {},
  }



  async componentDidMount() {

  }

  loadUserRights = async () => {
    let { userRights } = await Request.loadUserRights();
    this.setState({ financeBranchClaimDeskRights: userRights.financeBranchClaimDesk });
  };

  constructor(props) {
    super(props)
    this.table = React.createRef();
    this.loadUserRights();
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      params.time = this.state.time;
      const queryParams = new URLSearchParams(window.location.search);
      const inv = queryParams.get("inv");
      if (inv) {
        params.inovoiceNumber = inv; // send inv to API
      }

      let data = await Request.getBranchClaimDeskInvoices(params);

      let totalPendingAmount = 0;

      _.each(data.data, (item) => {
        if (item.status !== "Paid") {
          totalPendingAmount += item.associateAmount;
        }
        if (!userCheckBox[item._id]) {
          userCheckBox[item._id] = {
            userId: item._id,
            isChecked: false,
          };
        }
      });

      this.setState({ userCheckBox: userCheckBox, totalPendingAmount });
      resolve(data);
    });
  };


  selectUser = (item, studentId) => {
    let cloneUserCheckBox = _.clone(this.state.userCheckBox);

    cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId]
      .isChecked;

    this.setState({ userCheckBox: cloneUserCheckBox });
  };


  showDrawer = () => {
    let userArr = _.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showUploadDrawer: true });
    } else {
      notification.error({
        message: "Please select atleast 1 Student.",
      });
    }
  };

  showGenerate = () => {
    let userArr = _.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showGenerateDrawer: true });
    } else {
      notification.error({
        message: "Please select atleast 1 Student.",
      });
    }
  }


  closeUploadDrawer = () => {
    // clone existing userCheckBox and reset all isChecked to false
    let resetCheckBox = _.mapValues(this.state.userCheckBox, (item) => ({
      ...item,
      isChecked: false
    }));


    this.setState({ showUploadDrawer: false, userCheckBox: resetCheckBox }, () => {
      userCheckBox = resetCheckBox;
      this.table.current.reload();
    });
  };

  closeGenerateDrawer = () => {
    // clone existing userCheckBox and reset all isChecked to false
    let resetCheckBox = _.mapValues(this.state.userCheckBox, (item) => ({
      ...item,
      isChecked: false
    }));


    this.setState({ showGenerateDrawer: false, userCheckBox: resetCheckBox }, () => {
      userCheckBox = resetCheckBox;
      this.table.current.reload();
    });
  };


  openBranchInvoice = (record, type = "invoice") => {
    let url;
    switch (type) {
      case 'invoice':
        url = record.branchInvoice[0].url;
        break;
      case 'receipt':
        url = record.paymentReceipt[0].url;
        break;
    }
    let fullUrl = `${MEDIA_URL}${url}`;
    if (fullUrl) {
      window.open(fullUrl, '_blank');
    }
  }



  render() {
    let { showUploadDrawer, totalPendingAmount, showGenerateDrawer, financeBranchClaimDeskRights } = this.state;
    const currencySymbols = {
      USD: "$",      // US Dollar
      EUR: "€",      // Euro
      GBP: "£",      // British Pound
      INR: "₹",      // Indian Rupee
      AUD: "A$",     // Australian Dollar
      CAD: "C$",     // Canadian Dollar
      JPY: "¥",      // Japanese Yen
      CNY: "¥",      // Chinese Yuan
      NZD: "NZ$",    // New Zealand Dollar
      CHF: "CHF",    // Swiss Franc
      SGD: "S$",     // Singapore Dollar
      HKD: "HK$",    // Hong Kong Dollar
      SEK: "kr",     // Swedish Krona
      NOK: "kr",     // Norwegian Krone
      DKK: "kr",     // Danish Krone
      ZAR: "R",      // South African Rand
      AED: "د.إ",    // UAE Dirham
      SAR: "﷼",     // Saudi Riyal
      THB: "฿",      // Thai Baht
      MYR: "RM",     // Malaysian Ringgit
      IDR: "Rp",     // Indonesian Rupiah
      KRW: "₩",      // South Korean Won
      TRY: "₺",      // Turkish Lira
      RUB: "₽",      // Russian Ruble
      BRL: "R$",     // Brazilian Real
      MXN: "$",      // Mexican Peso
      PHP: "₱",      // Philippine Peso
      PLN: "zł",     // Polish Zloty
      HUF: "Ft",     // Hungarian Forint
      CZK: "Kč",     // Czech Koruna
    };
    let companyCurrency = companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR';

    const columns = [
      {
        title: 'Sr No.',
        key: 'serialNumber',
        width: 90,
        render: (text, record, index) => (
          <div>{index + 1}</div>
        )
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          !financeBranchClaimDeskRights.viewByBranch && (
            <>
              {record.status !== 'Paid' &&
                record.status !== 'Approved' && (
                  <Checkbox
                    style={{ marginLeft: '10px' }}
                    key={record._id}
                    checked={
                      userCheckBox[record._id]
                        ? userCheckBox[record._id].isChecked
                        : false
                    }
                    onChange={(e) => {
                      this.selectUser(e, record._id);
                    }}
                  />
                )}
            </>
          )
        )
      },
      {
        title: 'VID',
        key: 'studentVisionId',
        searchTextName: 'VID',
      },
      {
        title: 'Student Name',
        key: 'studentName',
        searchTextName: 'Student Name',
      },
      {
        title: 'PPT',
        key: 'passportNumber',
        searchTextName: 'Passport Number',
      },
      {
        title: 'Institute Student Id',
        key: 'instituteStudentId',
        searchTextName: 'Institute Student Id',
      },
      {
        title: 'Branch/ Ap Name',
        key: 'branchDetails.branchName',
      },
      {
        title: 'University/College',
        key: 'universityInstitutionName',
        searchTextName: 'University/College',
      },
      {
        title: 'Course Name',
        key: 'courseName',
        searchTextName: 'Course Name',
      },
      {
        title: 'Currency',
        key: 'currency',
        searchTextName: 'Currency',
      },
      {
        title: 'Comm Rate %',
        key: 'commissionFromCourse',
        render: (text, record) => (
          <div>{Number(text || 0).toFixed(2)}</div>
          // <div>{text.toFixed(2)}</div>
        )
      },
      {
        title: 'Tution Fee Paid',
        key: 'tutionFee',
        searchTextName: 'Tution Fee Paid',
        render: (text, record) => (
          <div>{currencySymbols[record.currency]}{text}</div>
        )
      },
      {
        title: 'Comm Recd',
        key: 'commissionTotal',
        render: (text, record) => (
          <div>{currencySymbols[record.currency]}{Number(text || 0).toFixed(2)}</div>
        )
      },
      {
        title: `${companyCurrency} Exchange Rate`,
        key: 'conversionRate',
        render: (text, record) => {
          const value = record.conversionRate ? record.conversionRate : text; // fallback
          return (
            <div>
              {currencySymbols[companyCurrency]}
              {value ? Number(value).toFixed(2) : "0.00"}
            </div>
          );
        }
      },
      {
        title: "Bank Charges",
        key: 'bankCharges',
      },
      {
        title: `Comm Recd. ${companyCurrency}`,
        key: 'grossPaymentReceived',
        render: (text, record) => (
          <div>{currencySymbols[companyCurrency]}{Number(text || 0).toFixed(2)}</div>
        )
      },
      {
        title: 'Sharing Rate',
        key: 'sharingRate',
      },
      {
        title: "Associates",
        key: 'associateAmount',
        render: (text, record) => (
          <div>{currencySymbols[companyCurrency]}{Number(text || 0).toFixed(2)}</div>
        )
      },
      {
        title: 'Invoice Number',
        key: 'branchInvoiceNumber',
        searchTextName: 'Invoice Number',
      },
      {
        title: 'Claim Number',
        key: 'claimNumber',
        searchTextName: 'Claim Number',
      },
      {
        title: 'Invoice File',
        key: 'branchInvoice',
        render: (text, record) => (
          record && record.invoiceUrl ? <Button icon='eye' type='primary' onClick={() => window.open(`${MEDIA_URL}${record.invoiceUrl}`, '_blank')} /> : null
        )
      },
      {
        title: 'Payment Receipt',
        key: 'paymentReceipt',
        render: (text, record) => (
          record && record.paymentReceipt && record.paymentReceipt.length ? <Button icon='eye' type='primary' onClick={() => this.openBranchInvoice(record, 'receipt')} /> : null
        )
      },
      {
        title: 'Status',
        key: 'status',
        filters: [
          { value: 'Pending', text: 'Pending' },
          { value: 'Approved', text: 'Approved' },
          { value: 'Paid', text: 'Paid' },
        ],
        render: (text, record) => (
          <div>
            <span>{record.status}</span>
            {record.rejectionReason && (
              <small style={{ color: 'red', display: 'block', marginTop: 4 }}>
                {record.rejectionReason}
              </small>
            )}
          </div>
        )
      }

    ];
    return (
      <PageHeaderWrapper title={` Branch/Ap Invoices `}>
        {
          showUploadDrawer ?
            <UplaodInvoiceDrawer counsellingData={counsellingData} onClose={this.closeUploadDrawer} />
            : null
        }
        {
          showGenerateDrawer ?
            <GenerateBranchInvoiceDrawer counsellingData={counsellingData} onClose={this.closeGenerateDrawer} />
            : null
        }

        <Card
          bordered={true}
          style={{
            marginBottom: '24px',
            borderRadius: '8px',
            borderLeft: '4px solid #1890ff',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)', // Added a subtle shadow for depth
          }}
          bodyStyle={{ padding: '16px 24px' }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

            {/* --- LEFT SIDE: TOTAL AMOUNT --- */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{
                fontSize: '11px',
                textTransform: 'uppercase',
                color: '#8c8c8c',
                letterSpacing: '1px',
                fontWeight: 600,
                marginBottom: '4px'
              }}>
                Total Amount Due
              </span>

              <div style={{
                fontSize: '24px',
                fontWeight: '700',
                color: '#262626',
                display: 'flex',
                alignItems: 'baseline',
                gap: '4px'
              }}>
                <span style={{ fontSize: '16px', fontWeight: '500', color: '#595959' }}>
                  {currencySymbols[companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR']}
                </span>
                <span>
                  {totalPendingAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                </span>
              </div>
            </div>

            {/* --- RIGHT SIDE: ACTIONS --- */}
            {
              !financeBranchClaimDeskRights.viewByBranch && (
                <div>
                  <Button
                    type="primary"
                    icon="upload"
                    size="large"
                    onClick={this.showGenerate}
                    style={{ borderRadius: '6px', fontWeight: 500 }}
                  >
                    Generate Invoice
                  </Button>
                </div>
              )
            }


          </div>
        </Card>

        <Card bordered={true}>
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 2000 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 10,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllBranchClaimDesk
